<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">
   {{alert.message}}
</re-alert>

<h1>Customers</h1>
<button  [disabled]="isReadOnlyUser" style="margin-top:15px; margin-bottom:20px" type="button" routerLink="./new" class="btn btn-primary" ><i class="fa fa-plus"  ></i> Add Customer</button>

<div id="searchResults">
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table table-striped table-bordered" id="customerSearchList" #customerSearchList>
      </table>
    </div>
    </div>
    <div class="spinner" *ngIf="loading">
      <div class="lspinner"></div>
    </div>
  </div>
</div>
